import ApiService from "../../../../../services/ApiService";
import translate from "../../../../../services/Translate";

export const updateExercise = (
  exerciseId: number,
  data: any,
  setIsEditing: Function,
  onSuccess: Function,
  language: string
) => {
  setIsEditing(true);
  ApiService.patch(`exercises/${exerciseId}`, data)
    .then(() => onSuccess())
    .catch((error) => {
      console.error("Error updating exercise:", error);
      alert(translate(language, "PAGES.EXERCISE.MAIN_INFOS_TAB.ERROR.UPDATE_EXERCISE"));
    })
    .finally(() => setIsEditing(false));
};

export const fetchInstances = (setInstances: Function, setLoading: Function, language: string) => {
  setLoading(true);
  ApiService.get("instances")
    .then((response) => setInstances(response.data.instances))
    .catch((error) => {
      console.error("Error fetching instances:", error);
      alert(translate(language, "PAGES.EXERCISE.MAIN_INFOS_TAB.ERROR.FETCH_INSTANCES"));
    })
    .finally(() => setLoading(false));
};
